import { useHistory, useLocation } from "react-router";
import { RouteUtils } from "utilities/route-utils";

const useFilterCollectionShareType = (paramIdToAppend?: string | number) => {
    const DEFAULT_COLLECTION_SHARE_TYPE = null; // Default value for collection share type

    const { pathname, search } = useLocation();
    const { replace } = useHistory();

    const collectionShareTypeKey = paramIdToAppend
        ? `collectionShareType_${paramIdToAppend}`
        : "collectionShareType";
    const skipKey = paramIdToAppend ? `skip_${paramIdToAppend}` : "skip";

    const {
        [collectionShareTypeKey]:
            collectionShareType = DEFAULT_COLLECTION_SHARE_TYPE,
    } = RouteUtils.queryStringToObject<{
        [collectionShareTypeKey]: number;
    }>(search);

    const onCollectionShareTypeChange = (newVal) => {
        const { collectionShareType: oldcollectionShareType, ...otherParams } =
            RouteUtils.queryStringToObject<{
                [collectionShareTypeKey]: boolean;
                [key: string]: any;
            }>(search);
        replace(
            RouteUtils.appendQueryParams(pathname, {
                ...otherParams,
                [collectionShareTypeKey]: newVal,
                [skipKey]: 0,
            })
        );
    };

    return {
        collectionShareType,
        collectionShareTypeKey,
        onCollectionShareTypeChange,
    };
};

export default useFilterCollectionShareType;
